var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.712,
    height: 25.829,
    viewBox: "0 0 25.712 25.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_01",
    d: "M69.974,75.825c-8.734.282-24.433-15.3-17.142-23.756L54.067,51a3.3,3.3,0,0,1,4.64.05c.031.031,2.019,2.615,2.019,2.615a3.325,3.325,0,0,1-.006,4.6L59.6,59.587a1.484,1.484,0,0,0-.194,1.605,13.681,13.681,0,0,0,6.138,6.151,1.462,1.462,0,0,0,1.605-.194l1.335-1.122a3.332,3.332,0,0,1,4.6-.006s2.583,1.988,2.615,2.019a3.33,3.33,0,0,1,0,4.7l-.978,1.129A6.606,6.606,0,0,1,69.974,75.825Zm1.975-22.841A2.984,2.984,0,1,1,68.964,50,2.984,2.984,0,0,1,71.949,52.984ZM73.1,61.969H64.832a1.009,1.009,0,0,1-1.009-1.009v-.765a3.361,3.361,0,0,1,3.361-3.361h3.555A3.361,3.361,0,0,1,74.1,60.195v.765A1.007,1.007,0,0,1,73.1,61.969Z",
    transform: "translate(-50.954 -50)",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.f43f57a2fa5e22b8b10fa8622a129963.svg";
export { ForwardRef as ReactComponent };